
/**
 * Custom component for Back Bar default menu sections.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 2.0.0
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *  2023-12-19 (1.0.0) (jhoward)
 *    - Copy from <WvSteakHouseDefaultSection> component to <back-bar-default-section> component.
 *
 *  2025-02-11 (1.1.0) (jhoward)
 *    - Add <menu-schedules> to the <back-bar-default-section> component if in admin view.
 *
 *  2025-04-08 (2.0.0) (jhoward)
 *    - Use <default-textual-section> and <default-visual-section> in <back-bar-default-section>.
 *    - Add textual and visual menu CSS tweaks to <back-bar-default-section>.
. */

import {defineComponent, PropType} from "vue";
import {Menu, MenuSection} from "../defs";
import DefaultVisualSection from "./visual/defaultVisualSection.vue";
import DefaultTextualSection from "./textual/defaultTextualSection.vue";

export default defineComponent({
  components: {
    DefaultTextualSection,
    DefaultVisualSection,
  },
  name: "BackBarDefaultSection",
  props: {
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    sectionModifier: {
      type: String,
      default: ''
    },
  },
})
